import * as React from "react";
import Stack from "@mui/material/Stack";

export default function LeadStatusChip({ style, label, icon }) {
	const cssClasses = {
		chipWrapper: {
			display: "flex",
			alignItems: "center",
			padding: "0.2rem 0.8rem",
			fontFamily: "Inter-Medium",
			fontStyle: "normal",
			fontWeight: 500,
			fontSize: "1.4rem",
			lineHeight: "2rem",
			/* identical to box height, or 143% */
			borderRadius: "1.6rem",
			textAlign: "center",
		},
		label: {
			marginLeft: "0.7rem",
			textTransform: "capitalize",
		},
	};

	return (
		<Stack direction="row" spacing={1}>
			<div
				label={label}
				style={{
					...cssClasses.chipWrapper,
					color: style.color,
					backgroundColor: style.backgroundColor,
					borderRadius: style.borderRadius ? style.borderRadius : "1.6rem",
					border: style.border ? style.border : "none",
					fontFamily: style.fontFamily ? style.fontFamily : "Inter-Medium",
					fontSize: style.fontSize ? style.fontSize : "1.4rem",
				}}
				variant="outlined"
			>
				{icon}
				<span
					style={{
						...cssClasses.label,
						color: style.color,
					}}
				>
					{label}
				</span>
			</div>
		</Stack>
	);
}
